import { React, useState, useEffect } from "react";
import styles from "./AqiIndexGrid.module.scss";
import { useGeoFetch, useGeoState } from "../../../components/GeoProvider";
import ErrorMessage from "../../../components/Layout/ErrorMessage";
import ErrorLogs from "../../../components/ErrorBoundary/errorlogs";
import { useAuthState } from "../../../components/AuthProvider";
import getVectorImage from "../../../utils/getVectorImage";
import Spinner from "../../../components/Loader/Spinner";
import toFixed from "../../../utils/toFixed";
import toTitleCase from "../../../utils/toTitleCase";
import getNumberFromString from "../../../utils/getNumberFromString";
import getStringFromNumberString from "../../../utils/getStringFromNumberString";
import getThresholdValueAqi from "../../../utils/getThresholdValueAqi";
const GraphCount = ({ data }) => {
  let trend = data.istrue === true ? "trendingup" : "trendingdown";
  if (data.aqi_parameter.toUpperCase() === "OVERALL") {
    return (
      <div className={styles.firstGridFormat}>
        <div className={styles.titleDiv}>
          <span> {getVectorImage("air_quality", "24px", "24px")} </span>
          <span style={{ color: "#002677", fontWeight: "700" }}>
            {toTitleCase(data.aqi_parameter)} AQI is{" "}
          </span>
          <span
            style={{
              color: getThresholdValueAqi(data.aqi_threshold_level).color,
              fontWeight: "700",
            }}
          >
            {" "}
            {getThresholdValueAqi(data.aqi_threshold_level).threshold}{" "}
          </span>
        </div>
        <div className={styles.valueDiv}>
          <span style={{ fontWeight: "700", color: "#002677" }}>
            {" "}
            {data.actual_value}
          </span>
          <span>{getVectorImage(trend, "24px", "24px")}</span>
          <span>
            {" "}
            {toFixed(data.change_actual_percentage, 2)}%, Main pollutant is{" "}
            {getStringFromNumberString(data.main_pollutant)}
            <sub>{getNumberFromString(data.main_pollutant)}</sub>
          </span>
        </div>
      </div>
    );
  } else {
    return (
      <div className={styles.gridFormat}>
        <div className={styles.titleDiv}>
          <span>
            {" "}
            {data.aqi_parameter.toLowerCase() === "grasses"
              ? getVectorImage("grasses", "24px", "24px")
              : getVectorImage(
                  data.data_type.toLowerCase(),
                  "24px",
                  "24px"
                )}{" "}
          </span>
          <span style={{ color: "#002677", fontWeight: "700" }}>
            {getStringFromNumberString(toTitleCase(data.aqi_parameter))}
            <sub>{getNumberFromString(toTitleCase(data.aqi_parameter))}</sub>
          </span>
        </div>
        <div className={styles.valueDiv}>
          <span style={{ fontWeight: "700", color: "#002677" }}>
            {" "}
            {data.actual_value}{" "}
          </span>
          <span>{getVectorImage(trend, "24px", "24px")}</span>
          <span> {toFixed(data.change_actual_percentage, 2)}%</span>
        </div>
      </div>
    );
  }
};
const AqiIndexGrid = ({ geo_type, geo_id }) => {
  const { locationName, displayDate } = useGeoState();
  const { user } = useAuthState();
  const [getAqiGridData, setAqiGridData] = useState();
  const [genderAge1, setGenderAge1] = useState();
  const [errorCode, setErrorCode] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const [errorSubject, setErrorSubject] = useState();
  const [errorOccured, seterrorOccured] = useState(false);
  const { data: staticData, error: staticDataError } = useGeoFetch(
    displayDate,
    displayDate,
    'aqigrid',
    '',
    '',
    {
      'geo_id' : geo_id,
      'geo_type' : geo_type,
    }
  );

  useEffect(() => {
    if (staticData !== null && staticData !== undefined) {
      if (staticData.response_code === 200) {
        ErrorLogs({
          message_type: "Activity",
          error_details: "Dashboard access success",
          user: user,
        });
        setAqiGridData(staticData.response_data);
      } else {
        setAqiGridData(null);
        setErrorCode(staticData.response_code);
        setErrorMessage(staticData.response_message);
        setErrorSubject(staticData.response_subject);
        seterrorOccured(true);
      }
    }
  }, [staticData]);

  return (
    <div className={styles.base}>
      <div className={styles.mainGridDiv}>
        {getAqiGridData !== undefined ? (
          getAqiGridData !== null ? (
            getAqiGridData.map((data_val, index) => {
              return <GraphCount key={index} data={data_val} isMale={true} />;
            })
          ) : (
            <div
              style={{
                padding: "30px 10px",
                fontSize: "18px",
                fontWeight: "700",
                color: "#7D7F81",
              }}
            >
              Data Not Available
            </div>
          )
        ) : (
          <Spinner />
        )}
      </div>
    </div>
  );
};

export default AqiIndexGrid;
